import React, {useEffect, useRef, useState} from 'react';
import {SearchOutlined} from '@ant-design/icons';
import {Link} from 'react-router-dom';
import {AutoComplete, Empty, Input, Spin} from 'antd';
import useDebounce from 'hooks/useDebounce';
import AlgoliaService from 'services/AlgoliaService';
import Flex from 'components/shared-components/Flex';
import {roundedInputStyle} from 'utils/Styles';

const HighlightSpan = (props) => {
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: props.value,
      }}
    ></span>
  );
};

const searchResult = (results) =>
  results.map((item) => {
    const highlights = item._highlightResult;
    return {
      key: item.id,
      value: item.id,
      label: (
        <Link to={`/docs/${item.id}`}>
          <div className="search-list-item">
            <p className="mb-0">
              Document: <HighlightSpan value={highlights.title.value} />
            </p>
          </div>
        </Link>
      ),
    };
  });

const DocumentationSearchInput = (props) => {
  const { close, isMobile, mode } = props;
  const [value, setValue] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const globalInputRef = useRef(null);
  const debouncedSearch = useDebounce(value, 2000);

  const onSelect = () => {
    setValue('');
    setOptions([]);
    if (close) {
      close();
    }
  };

  const onSearch = (searchText) => {
    setValue(searchText);
  };

  // Called when a search has been triggered debounced by 1s.
  useEffect(() => {
    const perform = async () => {
      if (debouncedSearch.length > 0) {
        const res = await AlgoliaService.getDocs({
          query: debouncedSearch,
          hitsPerPage: 10,
          page: 0,
        });
        setOptions(searchResult(res.data.hits));
      }
      setLoading(false);
    };

    perform();
  }, [debouncedSearch]);

  return (
    <div className="position-relative d-flex flex-column items-center justify-center">
      <AutoComplete
        ref={globalInputRef}
        className={`nav-search-input ${isMobile ? 'is-mobile' : ''} ${
          mode === 'light' ? 'light' : ''
        }`}
        dropdownClassName="nav-search-dropdown"
        options={loading ? [] : options}
        onSelect={onSelect}
        onSearch={onSearch}
        value={value}
        dropdownMatchSelectWidth={false}
        notFoundContent={
          loading ? (
            <Flex className="w-100" alignItems="center" justifyContent="center">
              <Spin />
            </Flex>
          ) : value.length === 0 ? (
            'Results will be shown here'
          ) : (
            <Empty description="No results" />
          )
        }
      >
        <Input
          placeholder="Search"
          prefix={<SearchOutlined className="mr-0" />}
          onInput={(e) => setLoading(true)}
          style={{ ...roundedInputStyle, height: 42 }}
        />
      </AutoComplete>
    </div>
  );
};

export default DocumentationSearchInput;
